import * as React$1 from "react";

//#region src/components/icon/static/generic-home.svg
var _path, _path2, _path3;
function _extends() {
	return _extends = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends.apply(null, arguments);
}
var SvgGenericHome = function SvgGenericHome$1(props) {
	return /* @__PURE__ */ React$1.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24
	}, props), _path || (_path = /* @__PURE__ */ React$1.createElement("path", { d: "M5.496 21.633q-1.036 0-1.767-.73A2.4 2.4 0 0 1 3 19.137V9.38a2.49 2.49 0 0 1 .996-1.999L10.5 2.504A2.4 2.4 0 0 1 12 2q.84 0 1.5.504l6.505 4.878q.47.348.733.877.263.53.263 1.122v9.756q0 1.036-.73 1.766a2.4 2.4 0 0 1-1.766.73zm0-2.496h13.008V9.38L12 4.503 5.496 9.38z" })), _path2 || (_path2 = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "M12 8.85c.635 0 1.15.515 1.15 1.15v6a1.15 1.15 0 0 1-2.3 0v-6c0-.635.515-1.15 1.15-1.15",
		clipRule: "evenodd"
	})), _path3 || (_path3 = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "M16.15 13A1.15 1.15 0 0 1 15 14.15H9a1.15 1.15 0 0 1 0-2.3h6c.635 0 1.15.515 1.15 1.15",
		clipRule: "evenodd"
	})));
};
var generic_home_default = SvgGenericHome;

//#endregion
export { generic_home_default as default };